"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalAppSwitcher_styled_exports = {};
__export(GlobalAppSwitcher_styled_exports, {
  StyledAppList: () => StyledAppList,
  StyledAppSelectorGoBackContainer: () => StyledAppSelectorGoBackContainer,
  StyledAppSelectorIconContainer: () => StyledAppSelectorIconContainer,
  StyledAppSwitcherListContainer: () => StyledAppSwitcherListContainer,
  StyledAppTitle: () => StyledAppTitle,
  StyledButton: () => StyledButton,
  StyledContainer: () => StyledContainer,
  StyledIcon: () => StyledIcon
});
module.exports = __toCommonJS(GlobalAppSwitcher_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var import_Popover = require("../../atoms/Popover/Popover.styled");
var import_atoms = require("../../atoms");
var import_baseTheme = __toESM(require("../../../themes/baseTheme"));
var StyledAppTitle = import_styled_components.default.span.withConfig({
  displayName: "GlobalAppSwitcherstyled__StyledAppTitle",
  componentId: "sc-1o0s7dd-0"
})(["font-size:", ";line-height:24px;padding-left:", ";"], import_baseTheme.default.typography.sizes.medium, import_baseTheme.default.measurements.medium);
var StyledContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalAppSwitcherstyled__StyledContainer",
  componentId: "sc-1o0s7dd-1"
})(function(_ref) {
  var withKebabMenu = _ref.withKebabMenu;
  return (0, import_styled_components.css)(["display:", ";", ""], withKebabMenu ? "none" : "block", (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["display:block;> div{", "{border:1px solid black;overflow-y:visible;background-color:", ";div#arrow{display:none;}ul{margin:0;li{height:48px;border-bottom:1px solid #d4d3c2;padding:0;&:last-child{border:0;}button{padding:8px;background:", ";height:100%;&:focus{background:none;outline:2px solid ", ";border-radius:4px;border:none;}&:hover,&:hover:focus{background:", ";}}span{color:", ";}}}}}"], import_Popover.StyledPopover, import_baseTheme.default.colors.neutral["light-20"], import_baseTheme.default.colors.neutral["light-20"], import_baseTheme.default.colors.beige[180], import_baseTheme.default.colors.beige["100"], import_baseTheme.default.colors.black)));
});
var StyledAppList = import_styled_components.default.div.withConfig({
  displayName: "GlobalAppSwitcherstyled__StyledAppList",
  componentId: "sc-1o0s7dd-2"
})(["overflow-y:auto;margin:0;padding:0;text-align:left;display:flex;align-items:center;img{width:32px;padding-left:0;}"]);
var StyledAppSelectorIconContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalAppSwitcherstyled__StyledAppSelectorIconContainer",
  componentId: "sc-1o0s7dd-3"
})(function(_ref2) {
  var theme = _ref2.theme;
  return (0, import_styled_components.css)(["width:100%;height:66px;background-color:", ";display:flex;border-top:1px solid ", ";border-bottom:1px solid ", ";align-items:center;box-sizing:border-box;position:relative;", ""], theme.colors.white, theme.colors.beige[140], theme.colors.beige[140], (0, import_mixins.mediaBreakpointUp)("md", "\n      display: none;\n    "));
});
var StyledAppSelectorGoBackContainer = (0, import_styled_components.default)(StyledAppSelectorIconContainer).withConfig({
  displayName: "GlobalAppSwitcherstyled__StyledAppSelectorGoBackContainer",
  componentId: "sc-1o0s7dd-4"
})(function(_ref3) {
  var theme = _ref3.theme;
  return (0, import_styled_components.css)(["height:72px;border:none;border-bottom:1px solid ", ";button{border-bottom:none;}", ""], theme.colors.beige[140], (0, import_mixins.mediaBreakpointUp)("md", "\n      display: none;\n    "));
});
var StyledButton = (0, import_styled_components.default)(import_atoms.Button).withConfig({
  displayName: "GlobalAppSwitcherstyled__StyledButton",
  componentId: "sc-1o0s7dd-5"
})(function(_ref4) {
  var theme = _ref4.theme;
  return (0, import_styled_components.css)(["height:100%;font-size:", " !important;"], theme.typography.sizes.medium);
});
var StyledAppSwitcherListContainer = import_styled_components.default.nav.withConfig({
  displayName: "GlobalAppSwitcherstyled__StyledAppSwitcherListContainer",
  componentId: "sc-1o0s7dd-6"
})(function(_ref5) {
  var theme = _ref5.theme;
  return (0, import_styled_components.css)(["position:fixed;top:0;left:0;width:100%;height:100%;background:", ";z-index:1002;overflow:auto;button:not(:first-child){border-bottom:1px solid ", ";}"], theme.colors.white, theme.colors.beige[140]);
});
var StyledIcon = import_styled_components.default.img.withConfig({
  displayName: "GlobalAppSwitcherstyled__StyledIcon",
  componentId: "sc-1o0s7dd-7"
})(["width:28px;height:28px;padding-left:", ";"], function(_ref6) {
  var theme = _ref6.theme;
  return theme.measurements.medium;
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledAppList,
  StyledAppSelectorGoBackContainer,
  StyledAppSelectorIconContainer,
  StyledAppSwitcherListContainer,
  StyledAppTitle,
  StyledButton,
  StyledContainer,
  StyledIcon
});
//# sourceMappingURL=GlobalAppSwitcher.styled.js.map